<template>
  <b-overlay :show="loading">
    <b-container fluid>

      <b-row align-h="center">
        <b-col cols="12" lg="8">

          <b-alert v-if="error" show variant="danger" class="mt-2">
            System error - contact tech support.
            <!-- TBD error component. -->
          </b-alert>

          <!-- PODCASTS -->
          <div class="div-section-header">
            <b-row>
              <b-col cols="12">
                <div>
                  <span class="txt-section-title">Dental Podcast Episodes</span>
                </div>
              </b-col>
            </b-row>
            <searchbar v-model="searchModel" @remove-filter="removeFilter"></searchbar>
            <b-row v-if="!noResults">
              <b-col cols="12">
                  <span class="txt-section-subtitle red">Available Now: {{totalRows | prettyNumber}} Dental Podcast Episodes</span>
              </b-col>
            </b-row>
            <b-row v-if="isFiltered && !noResults">
              <b-col cols="12" class="text-left">
                <b-link @click.prevent="searchAllContent">Show All Related Content &raquo;</b-link>
              </b-col>
            </b-row>
          </div>

          <b-alert v-model="noResults" class="mt-3" variant="info">
            No results found for this search.
          </b-alert>

          <!-- TBD podcastList component. -->
          <div class="div-section-body" v-if="!noResults">

            <div v-if="this.curPage === 1 && featuredPodcast !== null">
              <!-- Featured Cat Content -->
              <vpfeaturedcontent :fc=null :fp=featuredPodcast :fb=null :fh=featuredHash></vpfeaturedcontent>
            </div>

            <div v-for="(row,ix) in podcasts" v-bind:key="row.id">
              <div v-if="showMobileAd(ix)" class="mt-2">
                <mobilead :mb="getMobileAd(ix)"></mobilead>
              </div>
              <div v-if="featuredPodcast === null || featuredPodcast.id !== row.id">
                <b-row class="mt-3 pointer" @click.prevent="gotoPodcast(row.podcastShowHash,row.hash)">
                  <b-col cols="4" class="text-center">
                    <b-img fluid v-bind:src="row.photo" />
                    <div v-if="row.examTaken" class="text-center completed">COMPLETED</div>
                  </b-col>
                  <b-col cols="8" style="margin-left: -20px;">
                    <div class="class-title">{{row.title}} <!-- {{row.id}} --></div>
                    <div class="class-details">
                      {{row.speakerName}}
                      <br>Sponsor: {{row.companyName}}
                      <br>{{row.releaseDateUTC | prettyDate}}<span v-if="row.credits > 0"> - {{row.credits}} CEU (Self Study)</span>
                      <br><b-icon icon="clock"></b-icon>&nbsp;{{row.durationSec | prettySeconds}}
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>

            <b-row v-if="pages > 1" class="mt-4">
              <b-col>
                <b-pagination align="center" v-model="curPage" :total-rows="totalRows" :per-page="pageSize" @change="pageChange" @input="pageInput"></b-pagination>
              </b-col>
            </b-row>
          </div>

        </b-col>
      </b-row>

    </b-container>
  </b-overlay>
</template>

<script>
/* eslint-disable */

'use strict'

import service from "@/service/service";
import utils from "@/utils/utils"

export default {
  name: "Podcasts",
  data() {
    return {
      debug: false,
      loading: true,
      error: false,
      studentHash: this.$root.getToken(),
      msg: "Podcasts",
      blurb: "Podcasts: 0",
      podcasts: [],
      featuredPodcast: null,
      featuredHash: null,
      mobileAds: null,
      adIndexArr: [], // indexer into mobileAds.banners[]
      totalRows: 0,
      pageSize: 0,
      pages: 0,
      curPage: 1,
      searchModel: {
        path: '/podcasts',
        label: 'Search Podcasts',
        catId: this.$route.query.cid || null,
        compId: this.$route.query.coid || null,
        query: this.$route.query.q || null
      }
    }
  },
  props: {
    page: {
      type:String,
      required: false,
      default: "1"
    }
  },
  computed: {
    rows () {
      return this.podcasts.length
    },
    noResults() {
      return (this.podcasts.length == 0)
    },
    isFiltered() {   // return true if page is filtered
      let aout =  (this.searchModel.catId != null)
        || (this.searchModel.compId != null)
        || (this.searchModel.query != null)
      return aout
    }
  },
  methods: {
    gotoPodcast(ps,p) {  // podcastShowHash, podcastHash
      this.$router.push(`/podcast/${ps}/${p}`)
    },
    pageInput(page) {
      // console.log(`pageInput: ${page}`)
    },
    pageChange(page) {
      this.curPage = page
      this.doPodcasts()
      // console.log(`pageChange: ${page}`)
    },
    linkGen(pageNum) {
      let link = `/podcasts/${pageNum}`
      link += encodeURI(`?cid=${this.searchModel.catId}&coid=${this.searchModel.compId}&q=${this.searchModel.query}`)
      return link
    },
    setCurPage() {
      try {
        this.curPage = parseInt(this.page)
        if (this.curPage <= 0) this.curPage = 1
      }
      catch(e) {
        this.curPage = 1
      }
      // console.log( `this.page: ${this.page}  curPage: ${this.curPage}`)
    },
    removeFilter() {
      this.searchModel.catId = null
      this.searchModel.compId = null
      this.searchModel.query = null
      this.doPodcasts()
    },
    searchAllContent() {
      this.$router.push({ path: '/search', query: {cid: this.searchModel.catId, coid: this.searchModel.compId, q: this.searchModel.query }})
    },
    showMobileAd(ix) { // returns boolean indicating whether slot has mobile ad
      return this.adIndexArr[ix] !== -1
    },
    getMobileAd(ix) {
      let aout = {adId: 0, adUrls: []}
      if (this.adIndexArr[ix] != -1) {
        aout = this.mobileAds.banners[this.adIndexArr[ix]]
      }
      // console.log(aout)
      return aout
    },
    doPodcasts() {
      this.loading = true
      this.podcasts = []

      this.featuredPodcast = null
      this.featuredHash = null

      service
        .getPodcasts(this.studentHash, this.searchModel.catId, this.searchModel.compId, this.searchModel.query, this.curPage-1)
        .then(res => {
          if (this.debug) console.log(res);
          if (res.status && res.rowCount !== 0) {
            this.blurb = `Podcasts: ${res.rowCount}`
            this.podcasts = res.data
            this.totalRows = res.totalRows
            this.pageSize = res.pageSize
            this.pages = (res.pageSize) ? Math.ceil( this.totalRows/res.pageSize ): 0
            if (this.curPage > this.pages) this.curPage = this.pages

            this.mobileAds = (res.mobileAds) ? res.mobileAds : {indexStart:0, interval: 0, rows: 0, banners: []}
            this.adIndexArr = utils.getAdIndexArray( this.podcasts.length, this.mobileAds.banners.length, this.mobileAds.indexStart, this.mobileAds.interval )
            // this.featuredPodcast = (res.featuredPodcast) ? res.featuredPodcast.data[0] : null
            if (res.featuredContent.status) {
              this.featuredPodcast = (res.featuredContent.featuredPodcast) ? res.featuredContent.featuredPodcast.data[0] : null
              this.featuredHash = res.featuredContent.featuredHash
            }
          } else {
            this.blurb = "No podcasts found.";
          }
        })
        .finally(() => this.loading = false)
        .catch(e => console.log(e));
    }
  },
  created() {
    this.setCurPage()
    this.doPodcasts()
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Podcasts.vue